import {get} from 'lodash-es';
import {IChannelCatalogItemWithState} from 'views/programming/channel/contexts/memoryQueueApiProvider';

const getSplittedSort = (sort: string) => {
  const splitedSort = sort.split(':');
  return splitedSort;
};

export const sortQueue = (queue: IChannelCatalogItemWithState[], sort: string): IChannelCatalogItemWithState[] => {
  const tempQueue = [...queue];
  const [sortKey, sortOrder] = getSplittedSort(sort);

  const comparator = (key: string) => (a: IChannelCatalogItemWithState, b: IChannelCatalogItemWithState) => {
    const aValue = get(a, key);
    const bValue = get(b, key);

    if (aValue > bValue) {
      return sortOrder === 'asc' ? 1 : -1;
    }
    if (aValue < bValue) {
      return sortOrder === 'asc' ? -1 : 1;
    }
    return 0;
  };

  return tempQueue.sort(comparator(sortKey));
};
